"use client";

import { usePathname } from "next/navigation";

import { FooterFeedbackForm } from "./FooterFeedbackForm";

const PRODUCT_LINKS = [
  { href: "#values", label: "Возможности" },
  { href: "#audience", label: "Кому подходит" },
  { href: "#pricing", label: "Тарифы" },
  { href: "#how", label: "Как это работает" },
  { href: "#faq", label: "Частые вопросы" },
  { href: "/blog", label: "Блог" },
];

const LEGAL_LINKS = [
  { href: "/terms", label: "Публичная оферта" },
  { href: "/privacy", label: "Политика обработки ПДн" },
  { href: "/personal-data-consent", label: "Согласие на обработку ПДн" },
  { href: "/cookie-policy", label: "Политика cookie" },
];

export function Footer() {
  const pathname = usePathname();
  const toHref = (href: string) => (href.startsWith("#") && pathname !== "/" ? `/${href}` : href);

  return (
    <footer className="site-footer" aria-labelledby="footer-title">
      <h2 id="footer-title" className="visually-hidden">
        Служебная информация
      </h2>
      <div className="container footer__grid">
        <div className="footer__brand">
          <img
            className="footer__logo footer__logo--light"
            src="/landing/logo-light.svg"
            alt="СЛОТИСЛОТ"
            width={121}
            height={22}
          />
          <img
            className="footer__logo footer__logo--dark"
            src="/landing/logo-dark.svg"
            alt=""
            width={121}
            height={22}
            aria-hidden="true"
          />
          <p className="footer__desc">
            Онлайн-запись, оплата и абонементы для сферы услуг. Без комиссии за клиентов.
          </p>
          <p className="footer__contact">
            <a href="mailto:support@slotislot.ru">support@slotislot.ru</a>
          </p>
        </div>

        <nav className="footer__col" aria-label="Продукт">
          <h3 className="footer__heading">Продукт</h3>
          <ul className="footer__list">
            {PRODUCT_LINKS.map((link) => (
              <li key={link.href}>
                <a href={toHref(link.href)}>{link.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="footer__col" aria-label="Правовая информация">
          <h3 className="footer__heading">Правовая информация</h3>
          <ul className="footer__list">
            {LEGAL_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
            <li>
              <a href={toHref("#cookie-banner")} data-cookie-settings>
                Настройки cookie
              </a>
            </li>
          </ul>
        </nav>

        <div className="footer__col">
          <h3 className="footer__heading">Реквизиты</h3>
          <address className="footer__req">
            ООО «Полезные Цифры»
            <br />
            ИНН 5118006623 · КПП 783801001
            <br />
            ОГРН 1235100006646
            <br />
            Адрес: 190013, г. Санкт-Петербург, ул. Можайская, д. 2, литера А, помещ. 5Н, офис 410
            <br />
            Тел.: +7 921 939-79-39 · info@right-digits.ru
          </address>
          <p className="footer__site">
            <a href="https://slotislot.ru">slotislot.ru</a>
          </p>
        </div>
      </div>

      <div className="container footer__feedback">
        <div className="footer__feedback-intro">
          <h3 className="footer__heading">Обратная связь</h3>
          <p>
            Вопрос, идея или проблема? Напишите — ответим на указанный контакт. Или сразу на{" "}
            <a href="mailto:support@slotislot.ru">support@slotislot.ru</a>.
          </p>
        </div>
        <FooterFeedbackForm />
      </div>

      <div className="container footer__bottom">
        <p>© 2026 СЛОТИСЛОТ. Оператор — ООО «Полезные Цифры».</p>
        <p className="footer__credit">Продвижение — Отдел М</p>
        <a className="footer__up" href={toHref("#top")}>
          Наверх ↑
        </a>
      </div>
    </footer>
  );
}
